import { components } from "@certn/legacy-api/generated-schemas/people";
import { differenceInCalendarMonths, endOfMonth, parseISO } from "date-fns";

import { ValidationRuleType } from "./types";

export function requireXYearsEmploymentHistoryRule(
  rule: components["schemas"]["RequireXYearsEmploymentHistoryRule"]
): ValidationRuleType {
  return {
    rule,
    isValid: (
      employers: components["schemas"]["EmploymentCheckFieldValue"][]
    ) => {
      let oldestStartDate: Date | undefined;
      const minStartDate = new Date(
        Date.now() - 1000 * 60 * 60 * 24 * 365 * rule.value
      ); // X years ago

      const contactableEmployers = employers.filter(
        ({ can_contact }) => !!can_contact
      );

      // Calculate the total months
      const totalMonths = contactableEmployers.reduce(
        (acc, { start_date, end_date }) => {
          const startDate = new Date(start_date);

          if (!oldestStartDate || startDate < oldestStartDate) {
            oldestStartDate = startDate;
          }
          // Calculate the difference in months between end_date and start_date
          const monthsDifference = differenceInCalendarMonths(
            // End of month to ensure single month residences as August to August count as a month
            // Use the current date if end_date is not defined
            end_date ? endOfMonth(parseISO(end_date)) : new Date(Date.now()),
            startDate
          );
          return acc + monthsDifference;
        },
        0
      );

      const requiredMonths = rule.value * 12;
      return (
        !!oldestStartDate &&
        oldestStartDate <= minStartDate &&
        totalMonths >= requiredMonths
      );
    },
  };
}
